

import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'
import { t } from '@/utils/dicts/dict'
import { dictMap } from '@/utils/dicts/dicts'

@Component({
  name: 'detail-dialog'
})

export default class DetailDialog extends Vue {
  @PropSync('visible', { type: Boolean, default: !1 })
  private visibleSync!: boolean

  @Prop({ type: String })
  private title!: string

  @Prop({ type: Object })
  private data!: object

  private iDisable = !1

  private t = t

  private value (item: any, i: any) {
    return dictMap[i] ? dictMap[i](item) : (item || '')
  }

  private dictMap = dictMap
}
